// Vendor
import * as React from 'react';
import { SPOT_BRAND } from '@thredup/styleguide/src/variables/colors';

// Internal
import { SVGProps } from './types';

/**
 * @name IconCreditCard
 * @description Credit Card Icon
 */
const IconCreditCard: React.FC<SVGProps> = (props) => {
  const { className, desc, height, id, stroke, title, width } = props;

  return (
    <svg
      aria-labelledby={id}
      className={className}
      height={height}
      role="img"
      viewBox="0 0 87 87"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id={id}>{title}</title>
      <desc>{desc}</desc>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-1104.000000, -483.000000)"
          stroke={stroke}
          strokeWidth="1.689"
        >
          <g id="Group-31" transform="translate(1104.000000, 483.000000)">
            <path
              d="M52.9989,51.0552 L8.1459,34.9752 C6.6439,34.4362 5.8629,32.7832 6.4009,31.2812 L16.6269,2.7592 C17.1659,1.2572 18.8189,0.4762 20.3209,1.0142 L74.4619,20.4252 C75.9639,20.9632 76.7449,22.6182 76.2069,24.1182 L70.3359,40.4932"
              id="Stroke-1"
            ></path>
            <line
              x1="15.307"
              y1="30.4224"
              x2="44.966"
              y2="41.0564"
              id="Stroke-3"
            ></line>
            <line
              x1="17.0751"
              y1="25.4908"
              x2="30.0311"
              y2="30.1358"
              id="Stroke-5"
            ></line>
            <path
              d="M56.7836,56.6587 C56.7836,56.6587 51.4856,54.0037 51.4866,59.5677 C51.4876,61.7727 52.8006,64.1807 55.0006,66.9037 C57.2006,69.6267 60.0966,72.1337 61.0756,72.8727 C63.1276,74.4237 67.3606,74.1087 68.5106,72.8727"
              id="Stroke-7"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M68.9945,64.8443 C68.9945,64.8443 64.3845,69.0823 60.2465,62.4013 C58.5265,59.6223 55.7245,54.9183 54.1815,52.4043 C53.2725,50.9243 53.0205,49.0923 53.6665,47.4813 C54.2685,45.9783 55.5255,44.6623 58.1425,45.4093"
              id="Stroke-9"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M79.7733,53.1617 C79.7733,53.1617 66.4253,34.1787 64.0903,31.4127 C61.7563,28.6467 58.3533,26.7957 55.4273,28.1587 C52.6783,29.4387 50.8623,33.8567 57.9833,45.1937 C65.1043,56.5307 68.9193,59.6267 69.0013,64.7807 C69.0833,69.9337 65.9023,80.6717 79.5103,88.9187"
              id="Stroke-11"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M73.8539,31.6119 C73.8539,31.6119 90.3959,36.8099 92.6999,47.6809 C95.0029,58.5519 99.6109,86.2279 99.6109,86.2279"
              id="Stroke-13"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M27.0868,21.2593 L20.0778,18.7463 C19.8588,18.6673 19.7448,18.4273 19.8238,18.2083 L21.4828,13.5783 C21.5618,13.3603 21.8028,13.2453 22.0218,13.3243 L29.0308,15.8373 C29.2498,15.9153 29.3628,16.1563 29.2848,16.3753 L27.6248,21.0053 C27.5458,21.2243 27.3058,21.3373 27.0868,21.2593 Z"
              id="Stroke-15"
            ></path>
            <line
              x1="0.8441"
              y1="42.5835"
              x2="4.9611"
              y2="42.5835"
              id="Stroke-17"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></line>
            <line
              x1="2.9027"
              y1="40.4937"
              x2="2.9027"
              y2="45.0197"
              id="Stroke-19"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></line>
            <line
              x1="10.66"
              y1="50.1314"
              x2="14.777"
              y2="50.1314"
              id="Stroke-21"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></line>
            <line
              x1="12.7182"
              y1="48.0416"
              x2="12.7182"
              y2="52.5676"
              id="Stroke-23"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></line>
            <line
              x1="80.8607"
              y1="14.9117"
              x2="84.9777"
              y2="14.9117"
              id="Stroke-25"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></line>
            <line
              x1="82.9188"
              y1="12.8218"
              x2="82.9188"
              y2="17.3488"
              id="Stroke-27"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></line>
            <path
              d="M62.6015,35.5328 L58.0995,38.1328 C57.8335,38.2858 57.4945,38.1948 57.3405,37.9288 L54.3545,32.7578 C53.5085,31.2908 54.0105,29.4148 55.4775,28.5678 L55.6295,28.4798 C57.0965,27.6338 58.9725,28.1358 59.8185,29.6028 L62.8045,34.7738 C62.9575,35.0398 62.8675,35.3798 62.6015,35.5328 Z"
              id="Stroke-29"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

IconCreditCard.defaultProps = {
  desc: 'Credit Card Icon',
  height: 90,
  id: 'thredup-IconCreditCard-icon',
  stroke: SPOT_BRAND,
  title: 'Credit Card',
  width: 101
};

export { IconCreditCard };
